import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const pillList = css`
  display: flex;
  align-items: center;
  column-gap: var(${themeVariables.spacing.xs});
  margin-bottom: var(${themeVariables.spacing.md});
  /* Vertical padding gives the pills' focus ring (outline + 2px offset) room so it
     isn't clipped by the scroller, whose overflow-x forces vertical overflow to clip. */
  padding: var(${themeVariables.spacing.xxs}) var(${themeVariables.spacing.md});
`;
